import AsyncStorage from '@react-native-async-storage/async-storage';

// Fallback for web if AsyncStorage is not available
const storage = AsyncStorage || {
  getItem: async (key) => {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem(key);
    }
    return null;
  },
  setItem: async (key, value) => {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(key, value);
    }
  },
};

// Default settings
export const DEFAULT_SETTINGS = {
  soundBellEnabled: false,
  theme: 'system',
  healthWarningAcknowledged: false,
  red670nmEnabled: false,
  widerBeatRange: false,
  currentIndex: 0,
  volume: 1.0,
  beatsPerMinute: 60,
  minutesToPlay: 20,
  selectedHours: 0,
  selectedMinutes: 20,
};

// Initialize default settings if they don't exist
export async function initializeDefaults() {
  for (const [key, defaultValue] of Object.entries(DEFAULT_SETTINGS)) {
    try {
      const value = await storage.getItem(key);
      if (value === null) {
        await storage.setItem(key, JSON.stringify(defaultValue));
      }
    } catch (e) {
      console.warn(`initializeDefaults error for ${key}:`, e);
    }
  }
}

// Util for updating state values from storage
export async function applyPreferences(p) {
  // First ensure defaults are set
  await initializeDefaults();

  for (const key of Object.keys(p)) {
    try {
      const value = await storage.getItem(key);

      if (value !== null) {
        // value previously stored
        p[key] = JSON.parse(value);
      } else if (DEFAULT_SETTINGS[key] !== undefined) {
        // use default value if no stored value
        p[key] = DEFAULT_SETTINGS[key];
      }
    } catch (e) {
      console.warn("applyPreferences error: " + e);
      if (DEFAULT_SETTINGS[key] !== undefined) {
        p[key] = DEFAULT_SETTINGS[key];
      }
    }
  }
}

// Util for getting all stored data
export async function getData() {
  try {
    const keys = Object.keys(DEFAULT_SETTINGS);
    const data = {};
    for (const key of keys) {
      const value = await storage.getItem(key);
      if (value !== null) {
        data[key] = JSON.parse(value);
      }
    }
    return data;
  } catch (e) {
    console.warn("getData error: " + e);
    return {};
  }
}

// Util for saving to storage
export async function storeData(p) {
  for (const key of Object.keys(p)) {
    try {
      await storage.setItem(key, JSON.stringify(p[key]));
    } catch (e) {
      console.warn("storeData error: " + e);
    }
  }
}
